(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewInitiativesListController', Controller);

    Controller.$inject = ['$state', 'initAssessmentsByAssessor'];

    function Controller($state, initAssessmentsByAssessor) {

        if ($state.is('initiativeUpdateStatusReview.initiatives.review')
                || $state.is('initiativeUpdateStatusReview.initiatives.review.byInitiative.assessment')) {

            // Find the first non reviewed initiative
            var initiativeToReview = _.find(initAssessmentsByAssessor, { PlanInitiativeAssessment: {IsReviewed: false }}),
                initiativeId = initAssessmentsByAssessor[0].PlanInitiative.PlanInitiativeID;

            if (initiativeToReview) {
                initiativeId = initiativeToReview.PlanInitiative.PlanInitiativeID
            }

            $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables',
                { PlanInitiativeID: initiativeId },
                { location: 'replace' });
        }
    }
})();